import { useState, useEffect } from 'react';
import Dropdown from '../../Components/CustomDropdown/customdropdown';
import { useNavigate, useLocation } from 'react-router-dom';
import { useToast } from '../../Utils/toastContext';
import PhoneInput from '../../Components/CustomDropdown/input-phone';
import countriesData from '../../Data/CountryCodes.json';
const validator = require('validator');

export default function ContactUs({ onClose, isLogin }) {
  const BASE_URL = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [ticketResponse, setTicketResponse] = useState(null);
  const { showToast } = useToast();
  const [countries, setCountries] = useState([]);
  const [selectedCode, setSelectedCode] = useState('+61');
  const [form, setForm] = useState({
    name: '',
    email: '',
    message: '',
    file: null,
  });
  const [issueData, setIssueData] = useState([]);
  const [mobileNumber, setMobileNumber] = useState('');

  const [issueType, setIssueType] = useState(null);
  useEffect(() => {
    setCountries(countriesData);
  }, []);
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };
  const handleChange = (e) => {
    const { name, value, files } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: files ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!issueType) {
      showToast('Please select an issue type', 'error');
      return;
    }
    if (!form.message) {
      showToast('Please enter your message', 'error');
      return;
    }
    if (!form.name) {
      showToast('Please enter a subject', 'error');
      return;
    }
    setLoading(true);
    let toastMessage = null;
    try {
      const response = await submitApplicationAPI();
      if (response.status == 201) {
        // toastMessage = {
        //   message: response.message,
        //   type: "success",
        // };
        // onClose(); // Close the form on success
        setTicketResponse(response.data.ticket);
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const handleSubmitWithoutLogin = async (e) => {
    e.preventDefault();
    if (!issueType) {
      showToast('Please select an issue type', 'error');
      return;
    }
    if (!form.message) {
      showToast('Please enter your message', 'error');
      return;
    }
    if (!form.name) {
      showToast('Please enter a subject', 'error');
      return;
    }
    if (!form.email) {
      showToast('Please enter your email', 'error');
      return;
    }
    if (!form.email) {
      showToast('Please enter your email', 'error');
      return;
    }
    if (!validateEmail(form.email)) {
      showToast('Enter the valid email', 'error');
      return;
    }
    const normalizeMobile = (number) => {
      if (!number) return '';
      return number.replace(/^0+/, '');
    };

    const formattedMobile = normalizeMobile(mobileNumber);
    if (!validator.isMobilePhone(selectedCode + formattedMobile, 'any')) {
      console.log('country code ' + selectedCode);
      console.log('mobile number is ' + mobileNumber);
      console.log(validator.isMobilePhone(selectedCode + mobileNumber, 'any'));
      showToast('Please enter valid mobile number', 'error');
      return;
    }
    setLoading(true);
    let toastMessage = null;
    try {
      const response = await submitApplicationAPIWithoutLogin();
      if (response.status == 201) {
        // toastMessage = {
        //   message: response.message,
        //   type: "success",
        // };
        // onClose(); // Close the form on success
        setTicketResponse(response.data.ticket);
      } else {
        toastMessage = { message: response.message, type: 'error' };
      }
    } catch (err) {
      toastMessage = { message: err.message, type: 'error' };
    } finally {
      setLoading(false); // Ensure `loading` is false first
      // Show toast after loading is false
      if (toastMessage) {
        setTimeout(() => {
          showToast(toastMessage.message, toastMessage.type);
        }, 300); // Small delay if needed
      }
    }
  };
  const submitApplicationAPIWithoutLogin = async () => {
    const apiUrl = `${BASE_URL}/api/v1/tickets/public`;
    const bodyData = {
      subject: form.name,
      content: form.message,
      ticket_type: issueType,
      email_address: form.email,
      mobile_number: mobileNumber,
      country_code: selectedCode,
    };

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));

        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const submitApplicationAPI = async () => {
    const token = localStorage.getItem('jwtToken');
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    let apiUrl = `${BASE_URL}/api/v1/tickets/`;
    let bodyData = {
      subject: form.name,
      content: form.message,
      ticket_type: issueType,
    };
    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(bodyData),
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      throw new Error(error.message || 'Network error, please try again later');
    }
  };
  const GetAPIcalls = async (url) => {
    const token = localStorage.getItem('jwtToken');
    const apiUrl = `${BASE_URL}${url}`;
    const headers = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      const response = await fetch(apiUrl, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
          throw new Error('Session expired. Please log in again.');
        }
        const errorData = await response.json().catch(() => ({
          message: 'An unexpected error occurred',
        }));
        throw new Error(errorData.message || 'Something went wrong');
      }

      return await response.json();
    } catch (error) {
      console.error('API Call Error:', error); // Log full error for debugging
      throw new Error(
        typeof error.message === 'string'
          ? error.message
          : 'Network error, please try again later',
      );
    }
  };
  const getAllTypes = async () => {
    try {
      const response = await GetAPIcalls(`/api/v1/tickets/types`);

      if (response.status == 200) {
        let AllAccount = [];
        response.data.ticket_types.forEach((profile) => {
          AllAccount.push({
            value: profile.value,
            label: profile.label,
          });
        });

        setIssueData(AllAccount);
      } else {
        if (response.status === 401) {
          localStorage.removeItem('jwtToken');
          navigate('/login');
        }
      }
    } catch (err) {
      showToast(err.message, 'error');
    }
  };
  useEffect(() => {
    getAllTypes();
  }, []);
  return (
    <div className="w-full h-full flex items-center justify-center  px-4">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="relative w-full max-w-2xl">
        {/* Glow background */}
        {/* <div className="absolute -inset-1 bg-gradient-to-r from-[#375AE7] via-blue-500 to-purple-500 rounded-3xl blur opacity-10"></div> */}

        {/* Actual form card */}
        <div className="relative my-4 bg-white shadow-2xl rounded-3xl border-2 border-gray-200 py-4 px-8">
          {/* Header */}
          {!ticketResponse && (
            <div className="text-center mb-8">
              <div className="text-4xl mb-2">💬</div>
              <h2 className="text-3xl font-bold text-gray-800">Contact Us</h2>
              <p className="text-gray-500 mt-2">
                Tell us your issue and we’ll get back to you quickly
              </p>
            </div>
          )}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 
      w-9 h-9 flex items-center justify-center 
      rounded-full 
      bg-gray-50 hover:bg-gray-100 
      text-gray-500 hover:text-gray-700 
      transition-all duration-200"
            aria-label="Close"
          >
            <svg
              className="w-5 h-5"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          {!ticketResponse ? (
            <>
              {isLogin && (
                <form onSubmit={handleSubmit} className="space-y-6">
                  {/* Issue Type */}
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      <svg
                        className="w-4 h-4 text-[#375AE7]"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4 6h16M7 12h10M10 18h4"
                        />
                      </svg>
                      Issue Type
                    </label>

                    <div className="mt-2">
                      <Dropdown
                        options={issueData}
                        onSelect={(val) => setIssueType(val.value)}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      📝 Subject
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter subject here"
                      value={form.name}
                      onChange={handleChange}
                      className="mt-2 w-full px-4 py-3 rounded-xl border border-gray-200
              focus:border-[#375AE7] focus:border-2
              outline-none transition shadow-sm"
                    />
                  </div>
                  {/* Message */}
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      ✍️ Message
                    </label>
                    <textarea
                      name="message"
                      rows="4"
                      placeholder="Describe your issue..."
                      value={form.message}
                      onChange={handleChange}
                      className="mt-2 w-full px-4 py-3 rounded-xl border border-gray-200
              focus:border-[#375AE7] focus:border-2
              outline-none transition shadow-sm"
                    />
                  </div>

                  {/* File Upload */}
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      📎 Attachment
                    </label>

                    <div className="mt-2 border-2 border-dashed border-gray-300 rounded-xl p-4 text-center hover:border-[#375AE7] transition">
                      <input
                        type="file"
                        name="file"
                        onChange={handleChange}
                        className="w-full text-sm text-gray-500"
                      />
                      <p className="text-xs text-gray-400 mt-2">
                        Upload screenshot or document (optional)
                      </p>
                    </div>
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    className="w-full py-3 rounded-xl bg-gradient-to-r from-[#375AE7] to-[#1E201D]
            text-white font-semibold shadow-lg hover:scale-[1.02] transition"
                  >
                    🚀 Submit Request
                  </button>
                </form>
              )}
              {!isLogin && (
                <form onSubmit={handleSubmitWithoutLogin} className="space-y-6">
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      📧 Email
                    </label>
                    <input
                      type="text"
                      name="email"
                      placeholder="Enter your email here"
                      value={form.email}
                      onChange={handleChange}
                      className="mt-2 w-full px-4 py-3 rounded-xl border border-gray-200
              focus:border-black focus:border-2
              outline-none transition shadow-sm"
                    />
                  </div>
                  <div>
                    <label className="text-sm mb-2 font-medium text-gray-600 flex items-center gap-2">
                      📱 Mobile Number
                    </label>
                    <PhoneInput
                      countries={countries}
                      onChange={(val) => {
                        setSelectedCode(val.code);
                        setMobileNumber(val.number);
                      }}
                    />
                  </div>

                  {/* Issue Type */}
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      <svg
                        className="w-4 h-4 text-black"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        viewBox="0 0 24 24"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M4 6h16M7 12h10M10 18h4"
                        />
                      </svg>
                      Issue Type
                    </label>

                    <div className="mt-2">
                      <Dropdown
                        options={issueData}
                        onSelect={(val) => setIssueType(val.value)}
                      />
                    </div>
                  </div>
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      📝 Subject
                    </label>
                    <input
                      type="text"
                      name="name"
                      placeholder="Enter subject here"
                      value={form.name}
                      onChange={handleChange}
                      className="mt-2 w-full px-4 py-3 rounded-xl border border-gray-200
              focus:border-black focus:border-2
              outline-none transition shadow-sm"
                    />
                  </div>
                  {/* Message */}
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      ✍️ Message
                    </label>
                    <textarea
                      name="message"
                      rows="4"
                      placeholder="Describe your issue..."
                      value={form.message}
                      onChange={handleChange}
                      className="mt-2 w-full px-4 py-3 rounded-xl border border-gray-200
              focus:border-black focus:border-2
              outline-none transition shadow-sm"
                    />
                  </div>

                  {/* File Upload */}
                  <div>
                    <label className="text-sm font-medium text-gray-600 flex items-center gap-2">
                      📎 Attachment
                    </label>

                    <div className="mt-2 border-2 border-dashed border-gray-300 rounded-xl p-4 text-center hover:border-black transition">
                      <input
                        type="file"
                        name="file"
                        onChange={handleChange}
                        className="w-full text-sm text-gray-500"
                      />
                      <p className="text-xs text-gray-400 mt-2">
                        Upload screenshot or document (optional)
                      </p>
                    </div>
                  </div>

                  {/* Submit */}
                  <button
                    type="submit"
                    className="w-full py-3 rounded-xl bg-gradient-to-r from-[#375AE7] to-[#1E201D]
            text-white font-semibold shadow-lg hover:scale-[1.02] transition"
                  >
                    🚀 Submit Request
                  </button>
                </form>
              )}
            </>
          ) : (
            <div className="text-center py-10 px-4">
              {/* Success Icon */}
              <div className="text-5xl mb-3">🎉</div>

              {/* Title */}
              <h2 className="text-2xl font-bold text-gray-800">
                Request Created Successfully
              </h2>

              <p className="text-gray-500 mt-2">
                We’ve received your request and will respond shortly.
              </p>

              {/* Ticket Card */}
              <div className="mt-6 bg-gray-50 border rounded-2xl p-4 text-left space-y-2">
                <div className="flex justify-between items-center">
                  <span className="text-sm text-gray-500">Request ID</span>
                  <button
                    onClick={() =>
                      navigator.clipboard.writeText(ticketResponse.ticket_id)
                    }
                    className="text-blue-600 text-sm hover:underline"
                  >
                    Copy
                  </button>
                </div>

                <p className="font-semibold text-gray-800">
                  {ticketResponse.ticket_id}
                </p>

                <div className="text-sm text-gray-600">
                  <p>
                    <b>Status:</b> {ticketResponse.status}
                  </p>
                  <p>
                    <b>Type:</b>{' '}
                    {issueData.find(
                      (item) => item.value === ticketResponse.ticket_type,
                    )?.label || ticketResponse.ticket_type}
                  </p>
                  <p>
                    <b>Email:</b> {ticketResponse.requester_email_address}
                  </p>
                  <p>
                    <b>Created:</b> {ticketResponse.date_created}
                  </p>
                </div>
              </div>

              {/* Actions */}
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <button
                  onClick={() => {
                    setTicketResponse(null);
                    setForm({ name: '', email: '', message: '', file: null });
                    setMobileNumber('');
                    setSelectedCode('+61');
                    setIssueType(null);
                  }}
                  className="flex-1 py-2 rounded-xl bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
                >
                  Create Another Request
                </button>

                <button
                  onClick={onClose}
                  className="flex-1 py-2 rounded-xl bg-gradient-to-r from-[#375AE7] to-[#1E201D] text-white font-medium"
                >
                  Close
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
